import { gql } from "@apollo/client";

export default gql`
  mutation deleteTopicMutation($topicId: Int!) {
    deleteTopic(topicId: $topicId) {
      ok
    }
  }
`;
